module.exports = __webpack_public_path__ + "fbc4543a379c1f65b580e6e801c1998b.png";